import React from "react";
import "../styles/FeeModules.css";

export default function ScholarshipManager() {
  return (
    <div className="scholarship-manager-container">
      <h2>Scholarship / Concession Management</h2>
      <p>Apply and manage scholarships or concessions for students.</p>
      {/* Add scholarship management form/table here */}
      <div>
        <p>(Scholarship/Concession management functionality goes here)</p>
      </div>
    </div>
  );
}